import { Injectable } from '@angular/core';
//import { GlobalConstants } from 'src/app/common/global-constants';
import { ClientModel } from '../models/client.model';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { HttpClient } from '@angular/common/http';
import * as _ from 'lodash';
import { UserService } from './user.service';

@Injectable({
  providedIn: 'root'
})
export class ClientService {
  //readonly BaseURI = GlobalConstants.apiURL;
  BaseURI : string;
  readonly apiController = "/Clients";
  formData : ClientModel;
  list : ClientModel[];



  form: FormGroup = new FormGroup({
      clientId: new FormControl(null),
      fullName: new FormControl('',[Validators.required, Validators.minLength(3)]),
      position : new FormControl(null),
      email : new FormControl('',[Validators.required, Validators.email]),
      email2 : new FormControl('',Validators.email),
      phone1: new FormControl('',[Validators.minLength(5)]),
      phone2 : new FormControl(null),
  //    phone3 : new FormControl(null),
      ext1 : new FormControl(null),
      ext2 : new FormControl(null),
   //   ext3 : new FormControl(null),
      company : new FormControl(null),
      address : new FormControl(null),
      provinceCode : new FormControl(null),
      zipCode : new FormControl(null),
      countryName : new FormControl(null),
      countryCode : new FormControl(null),
      status : new FormControl(null),
      note : new FormControl(null),
      createBy : new FormControl(null),
      createTime :new FormControl(null),

    });
    constructor(private http : HttpClient, private userservice : UserService) {
      console.log("constructor : ClientService ");
      this.BaseURI = window.location.origin + "/api";
    }

    populateForm(item) {

      this.form.setValue(item);
     }


     postDetail()
     {


        return this.http.post(this.BaseURI + this.apiController, this.formData);
     }

     putDetail()
     {
        return this.http.put(this.BaseURI + this.apiController + "/" + this.formData.clientId, this.formData);
     }

     getDetail(id)
     {
        return this.http.get(this.BaseURI + this.apiController + "/" + id);
     }

     refreshList()
     {

       return this.http.get(this.BaseURI + this.apiController).toPromise().then(
         res => {
           this.list = res as ClientModel[];

         }
       );
     }

     getList()
     {
        return this.http.get(this.BaseURI + this.apiController);
      // this.list = this.http.get(this.BaseURI + "/Customers");
       //return this.list.snapshotChanges();


     }

     insertData(item : ClientModel) {

      item.createBy = this.userservice.getUserID();

       return this.http.post(this.BaseURI + this.apiController, _.omit(item, ["clientId", "createTime"]));
     }

     updateData(item : ClientModel) {
       return this.http.put(this.BaseURI + this.apiController + "/" + item.clientId, item);
     }


     deleteData(id)
     {
       return this.http.delete(this.BaseURI + this.apiController + "/" + id);

     }
   /*
     findData(key)
     {
       return this.http.get(this.BaseURI + this.apiController + "/Find?keywords=" + key);
     }
   */
     initializeFormGroup(){

       this.form.setValue({
          clientId: null,
          fullName: null,
          position : null,
          email : null,
          email2 : null,
          phone1: null,
          phone2 : null,
          //phone3 : null,
          ext1 : null,
          ext2 : null,
         // ext3 : null,
          company : null,
          address : null,
          provinceCode : null,
          zipCode : null,
          countryCode : null,
          countryName : null,
          status : null,
          note : null,
          createBy : null,
          createTime : null,
       });

     }
}
